export const tableCustomStyles = {
  '.table-container': {
    maxHeight: 'calc(100vh - 200px)',
    overflow: 'auto',
  },
  '.table': {
    tableLayout: 'auto',
  },
};
